<div class="main_plus_side">
    <div class="sidesheet_temp mat-elevation-z2">
        <ng-container *ngIf="periodosNavBar">
            <nav-bar [navBarItems]="periodosNavBar" [initialValue]="periodoID" [placeholder]="'Seleccione un año'" [navOnChange]="true" [verticalLayout]="true"></nav-bar>
        </ng-container>
        <nivelaciones-convenciones [direccion]="'vertical'" [asistencia]="true" [data]="tiposAsistencia" [dataFilterValues]="['A', 'A0', 'A1', 'A2', 'A3', 'R', 'R0', 'R1', 'R2', 'R3']"></nivelaciones-convenciones>
    </div>
    <div class="main_sheet">
        <div class="flex-wrap" style="align-items:center;">
            <div class="inline-flex" style="width: 30%">
                <mat-form-field class="full-width">
                    <input matInput placeholder="Filtrar por nombre" (keyup)="filtroTexto($event.target.value)" autocomplete="off">
                </mat-form-field>
            </div>
            <span class="spacer"></span>
            <div class="flex-wrap" style="align-items:center;">
                <label style="margin-right: 4px; opacity:.6;">Ver valores como:</label>
                <button mat-button class="view-mode" (click)="changeViewMode('percentage')" [ngClass]="{'active': viewMode != 'numbers'}">Porcentaje
        </button>
                <button mat-button class="view-mode" (click)="changeViewMode('numbers')" [ngClass]="{'active': viewMode == 'numbers'}">Numérico
        </button>
            </div>
        </div>
        <div>
            <mat-table #table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                <ng-container matColumnDef="Curso">
                    <mat-header-cell *matHeaderCellDef style="flex: 1;">Curso</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1;">{{element.curso}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Alumno">
                    <mat-header-cell *matHeaderCellDef style="flex: 3;">Alumno</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 3;">{{element.alumno}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Materias">
                    <mat-header-cell *matHeaderCellDef style="flex: 3;">Materias</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 3;">{{element.materia}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="NotaPeriodo">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">Nota <br>periodo
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">{{element.notaPeriodo}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="NotaAcumulada">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">Nota <br>acumulada
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">{{element.notaAcumulada}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="AyR">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">Ausencias <br>y retardos
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">
                        <div style="position: relative;">
                            <div class="circulo warn" style="cursor: pointer;" (click)="getDetails(element, element.materiaId)">
                                <small>
                  {{viewMode != 'numbers' ? element.porcentaje + '%' : element.numerico}}
                </small>
                            </div>
                            <div *ngIf="element.detalle && element.detalle.show" class="detail-container mat-elevation-z24">
                                <div class="inline-flex">
                                    <div class="flex-wrap" style="justify-content:space-between;">
                                        <label class="inline-flex"><strong>Ausencias</strong></label>
                                        <label class="inline-flex"><strong>Retardos</strong></label>
                                        <label class="inline-flex"><strong>Total</strong></label>
                                    </div>
                                    <ng-container *ngFor="let appendable of ['', '0', '1', '2', '3']">
                                        <div class="flex-wrap">
                                            <ng-container *ngFor="let tipoAusencia of ['A' + appendable, 'R' + appendable, 'AR' + appendable]; index as i">
                                                <!--<small><pre>{{tipoAusencia | json}}</pre></small>-->
                                                <div class="inline-flex">
                                                    <ng-container *ngIf="i < 2">
                                                        {{tipoAusencia}}:
                                                    </ng-container>
                                                    {{i == 1 ? (element.detalle.listaDetalles | asistenciaCodigo: tipoAusencia).retardos : (element.detalle.listaDetalles | asistenciaCodigo: tipoAusencia).numerico}}
                                                    <ul class="detail-list" *ngIf="i < 2 && (element.detalle.listaDetalles | asistenciaCodigo: tipoAusencia).fechas.length > 0">
                                                        <li *ngFor="let fecha of (element.detalle.listaDetalles | asistenciaCodigo: tipoAusencia).fechas" style="color: gray">
                                                            <small>{{fecha}}</small>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="FaltaTarea">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">Falta de <br>tareas
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">
                        <ng-container *ngIf="element.faltaTareaAcumula">
                            {{element.faltaTareaAcumula}}
                        </ng-container>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let element; columns: displayedColumns;">
                </mat-row>
            </mat-table>
        </div>
    </div>
</div>